import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualForOf,
  CdkVirtualScrollViewport
} from '@angular/cdk/scrolling';
import { CommunicationPanelCardComponent } from '@app/pages/constructor/constructor-components/communication-chart/components/communication-panel-card/communication-panel-card.component';
import { CommunicationChartPanelStore } from '@app/pages/constructor/constructor-components/communication-chart/store/communication-chart-panel.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MessageNotificationViewModel } from '@app/pages/constructor/constructor-components/communication-chart/models/message-notification-view.model';
import { MessageNotificationProgress } from '@app/pages/constructor/constructor-components/communication-chart/enum/message-notification-progress.enum';
import { AsyncPipe, JsonPipe, NgClass } from '@angular/common';
import { CommunicationChartGetParams } from '@app/pages/constructor/constructor-components/communication-chart/models/communication-chart-panel.model';
import { timer } from 'rxjs';

@Component({
  selector: 'app-communication-chart-panel',
  imports: [
    MatButton,
    TranslatePipe,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    CommunicationPanelCardComponent,
    NgClass,
    CdkVirtualScrollViewport,
    AsyncPipe,
    JsonPipe
  ],
  templateUrl: './communication-chart-panel.component.html',
  styleUrl: './communication-chart-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommunicationChartPanelComponent implements OnInit {
  @ViewChild('viewport') viewport: CdkVirtualScrollViewport;
  @Output() closePanel = new EventEmitter();

  public communicationChartsNotification: MessageNotificationViewModel[] = [];
  public isActiveFilterType: MessageNotificationProgress | null = null;

  public readonly messageNotificationProgress = MessageNotificationProgress;
  public readonly commentsUnreadCount$ =
    this.communicationChartPanelStore.commentsUnreadCount$;

  private isLoadingNextPage = false;

  constructor(
    private communicationChartPanelStore: CommunicationChartPanelStore,
    private destroyRef: DestroyRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.communicationChartPanelStore.getCommunicationChartPanel({
      isGetAll: false,
      progressMessages: null
    } as CommunicationChartGetParams);
    this.streamToCommunicationChartsData();
  }

  public sortBy(
    type: MessageNotificationProgress | null,
    isGetAll: boolean
  ): void {
    this.isActiveFilterType = type;

    this.communicationChartPanelStore.patchState({
      commentsChartsPanel: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 0
    });

    this.communicationChartPanelStore.getCommunicationChartPanel({
      isGetAll: isGetAll,
      progressMessages: type,
      currentPage: 1
    });
  }

  public deleteNotificationItem(notificationId: string): void {
    this.communicationChartPanelStore.deleteCommunicationNotification(
      notificationId
    );

    this.communicationChartsNotification =
      this.communicationChartsNotification.filter(
        data => data.id !== notificationId
      );
  }

  public notifyCommunication(notificationId: string): void {
    this.communicationChartPanelStore.viewCommunicationNotify(notificationId);
  }

  public markedAll(): void {
    this.communicationChartPanelStore.viewAllCommunicationNotify();
  }

  public onScroll(): void {
    if (!this.viewport || this.isLoadingNextPage) return;

    const end = this.viewport.measureScrollOffset('bottom');
    
    if (end < 300) {
      this.isLoadingNextPage = true;
      this.communicationChartPanelStore.loadNextPage();
      timer(500).subscribe(() => {
        this.isLoadingNextPage = false;
      });
    }
  }

  private streamToCommunicationChartsData(): void {
    this.communicationChartPanelStore.commentsChartsPanel$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.communicationChartsNotification = data;
          this.cdr.detectChanges();
        }
      });
  }
}
